import React, { useEffect } from "react";

function PhotoModal({ isOpen, closeModal, totalImages = 4 }) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);
  if (!isOpen) return null;

  const getImagePath = (index) => `/assets/img/mosaic/${index + 1}.webp`;

  return (
    <div
      className="fixed inset-0 bg-black/80 flex justify-center items-center z-50 p-4 sm:p-6"
      onClick={closeModal}
    >
      <div
        className="bg-white overflow-y-auto photo-modal-scroll w-full max-w-4xl max-h-[calc(100vh-2rem)] rounded-xl shadow-2xl relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="absolute top-5 right-5 w-8 h-8 flex items-center justify-center text-2xl font-light text-gray-400 hover:text-gray-700 z-50 transition-colors leading-none"
          onClick={closeModal}
          aria-label="Fermer"
        >
          ×
        </button>
        <div className="flex flex-col items-center p-5 sm:p-8">
          {Array.from({ length: totalImages }).map((_, index) => (
            <img
              key={index}
              src={getImagePath(index)}
              alt={`Menu ${index + 1}`}
              className="mb-6 last:mb-0 w-full object-contain rounded-lg"
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default PhotoModal;
